<div class="wrap" *ngIf="!confirmAdd">
    <h3>Ajouter une place de parking</h3>
    <p>Shouhaitez-vous ajouter une place de parking ? </p>
    <div class="btn_action">
      <button class="canceled" (click)="dialogRef.close()">Annuler</button>
      <button class="btn_confirm" (click)="addSlot()">Confirmer</button>
    </div>
  
  </div>
  <div class="confirm" *ngIf="confirmAdd">
    <div class="validation_mail">
      <div class="check">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
    <h4>{{'addSlot.confirmAdd.label' | translate}}</h4>
  </div>
  